'use es6';

import { Record } from 'immutable';
export default Record({
  adWordsTrackingTemplate: null
});